import React from 'react';

/**
 * Outline trash glyph tuned for circular action buttons.
 * Clear lid + can silhouette so it stays readable at 16px.
 */
export function TrashIcon({ className, size = 16, strokeWidth = 2.1 }) {
  const s = Number(size) || 16;
  const sw = Number(strokeWidth) || 2.1;
  return (
    <svg
      className={className}
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4 7h16"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
      />
      <path
        d="M10 4h4"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
      />
      <path
        d="M6 7l1 13h10l1-13"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11v6M14 11v6"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default TrashIcon;
